import { render } from "./work-detail.vue?vue&type=template&id=615de5f1"
import script from "./work-detail.vue?vue&type=script&lang=js"
export * from "./work-detail.vue?vue&type=script&lang=js"

import "./work-detail.vue?vue&type=style&index=0&id=615de5f1&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__